module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"files:tooltips:btn-download":"Скачать файл","files:tooltips:btn-delete":"Удалить файл"},"en":{"files:tooltips:btn-download":"Download file","files:tooltips:btn-delete":"Delete file"}}')
  delete Component.options._Ctor
}
